<template>
  <div class="item">
    <div class="item-header">
      <div class="item-header-name">
        <span class="item-header-name-line" />
        <span>全专业的技术认证能力</span>
        <span class="item-header-name-line" />
      </div>
      <div class="item-header-desc">PROFESSIONAL TECHNICAL CERTIFICATION ABILITY</div>
    </div>

    <div class="item-content">
      <div class="top">
        <div class="child">
          <span>标准化项目</span>
          <span>管理能力</span>
        </div>
        <div class="child">
          <span>主流数据库</span>
          <span>专业认证</span>
        </div>
        <div class="child">
          <span>AI人工智能</span>
          <span>技术认证</span>
        </div>
        <div class="child">
          <span>各类国内外厂商</span>
          <span>专业技术认证</span>
        </div>
        <div class="child">
          <span>信息安全</span>
          <span>专业认证</span>
        </div>
        <div class="child">
          <span>虚拟化</span>
          <span>专业认证</span>
        </div>
      </div>
      <div class="bottom">
        <div class="child">
          <span>网络安全</span>
          <span>技术认证</span>
        </div>
        <div class="child">
          <span>国际标准化</span>
          <span>服务能力认证</span>
        </div>
        <div class="child">
          <span>云计算</span>
          <span>专业认证</span>
        </div>
        <div class="child">
          <span>标准化运维</span>
          <span>服务认证</span>
        </div>
        <div class="child">
          <span>大数据应用与</span>
          <span>管理能力认证</span>
        </div>
      </div>
    </div>
      
  </div>
</template>

<script>
import IMAGE from '../../assets/images/about/96.png'

export default {
  data () {
    return {
      IMAGE
    }
  }
}
</script>

<style lang="less" scoped>
.item {
  background: url('../../assets/images/about/96.png');
  background-size: 100% 100%;
  margin-top: 40px;
}
.item-header {
  color: #fff;
}
.item-content {
  position: relative;
  height: 328px;
  .top {
    display: flex;
  }
  .bottom {
    display: flex;
    position: absolute;
    left: 96px;
    bottom: 20px;
  }
  .child {
    display: flex;
    flex-direction: column;
    background: url('../../assets/images/about/1592.png');
    background-size: 100% 100%;
    width: 192px;
    height: 192px;
    align-items: center;
    justify-content: center;
  }
}
</style>